import React from 'react';
import logo from './logo.png';
import styles from './logo.module.scss';
import { toggleFlyingButton } from '../../reducers/quiz/quiz.actions';
import { useDispatch } from 'react-redux';
import { OUR_SITE_LINK } from '../../constants';

interface LogoProps {
	type?: string
	src: string
	link?: string
}

export default function Logo({type, src, link}:LogoProps) {
	const dispatch = useDispatch();

	const Img = <img 
		className={type ? styles[type] : styles.default} 
		src={src == 'our' ? logo : src}
		alt=""
		onMouseEnter={() => dispatch(toggleFlyingButton(false))}
		onMouseLeave={() => dispatch(toggleFlyingButton(true))}
	/>

	return (type == 'footer' ? Img :
		<a rel='noopener noreferrer' target="_blank" href={link || (src == 'our' ? OUR_SITE_LINK : '#')}>{Img}</a>)
}